import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { Button, IconButton, Typography } from "@mui/material";
import { border, borderRadius, borders, Container } from "@mui/system";

interface ScrollImageButtonProps {
    onLeft: () => void;
    onRight: () => void;
    outOf: number;
    index: number;
}

export const ScrollImageButtons = (props: ScrollImageButtonProps) => {
    return (
        <>
            <IconButton
                aria-label="settings"
                onClick={(e: any) => {
                    e.stopPropagation();
                    props.onLeft();
                }}
                title="previous image"
                size="large"
                sx={{ padding: "0 0 0 10px" }}
                color="secondary"
            >
                <ArrowLeft sx={{ fontSize: 40 }} />
            </IconButton>
            <Typography
                fontSize="1.2rem"
                sx={{ transform: "translateY(4px)" }}
            >
                {props.index + 1} / {props.outOf}
            </Typography>
            <IconButton
                size="large"
                aria-label="settings"
                onClick={(e: any) => {
                    e.stopPropagation();
                    props.onRight();
                }}
                sx={{ padding: 0 }}
                title="next image"
                color="secondary"
            >
                <ArrowRight sx={{ fontSize: 40 }} />
            </IconButton>
        </>
    )
}